"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const typesafe_actions_1 = require("typesafe-actions");
exports.LOAD = 'REDUX_PERSISTENCE_LOAD';
exports.load = (state) => typesafe_actions_1.action(exports.LOAD, state);
exports.SAVE = 'REDUX_PERSISTENCE_SAVE';
exports.save = (state) => typesafe_actions_1.action(exports.SAVE, state);
